import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@ohif/ui-next';

const FloatingInfoBanner: React.FC<{
  text: string;
  buttonText: string;
  buttonUrl: string;
  onClose?: () => void;
}> = ({ text, buttonText, buttonUrl, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = React.useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  }, [onClose]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9999] max-w-sm">
      <div className="bg-[#1a1a2e] backdrop-blur-sm shadow-2xl rounded-xl border border-[#5893df]/30 overflow-hidden transform transition-all duration-300 hover:scale-[1.02]">
        {/* Header bar */}
        <div className="bg-gradient-to-r from-[#5893df] to-[#4a7ab8] px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <span className="text-white text-xs font-semibold tracking-wider" dir="rtl">تنبيه</span>
          </div>
          <button
            type="button"
            onClick={handleClose}
            className="text-white/80 hover:text-white transition-colors p-1 hover:bg-white/10 rounded cursor-pointer"
            aria-label="Close banner"
          >
            <Icons.Close className="w-4 h-4 pointer-events-none" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="flex items-start gap-3 mb-4">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-8 h-8 rounded-full bg-[#5893df]/20 flex items-center justify-center">
                <Icons.Info className="w-4 h-4 text-[#5893df]" />
              </div>
            </div>
            <div className="flex-1">
              <p className="text-white/90 text-base leading-relaxed" dir="auto">{text}</p>
            </div>
          </div>

          {/* Button */}
          <button
            className="w-full h-10 bg-gradient-to-r from-[#5893df] to-[#4a7ab8] hover:from-[#4a7ab8] hover:to-[#3d6599] text-white font-medium rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 group"
            onClick={() => window.open(buttonUrl, '_blank', 'noopener,noreferrer')}
          >
            <span>{buttonText}</span>
            <Icons.ExternalLink className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
};

FloatingInfoBanner.propTypes = {
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default FloatingInfoBanner;
